import { Injectable } from '@angular/core';
import { AlertController } from 'ionic-angular';

@Injectable()
export class statusNFService {

    alertNF: any;
    title: string = "STATUS NF";
    
    constructor(public alertCtrl: AlertController) { }

    doStatusNF() {
        return new Promise((resolve, reject) => {
            if(!this.alertNF) {
                this.alertNF = this.alertCtrl.create();
                this.alertNF.setTitle(this.title);

                this.alertNF.addInput({ type: 'checkbox', value: '0',  disabled: true, checked: false, id: 'optGroup', label: 'Status Sapiens' });
                this.alertNF.addInput({ type: 'checkbox', value: 'a1', checked: false, label: 'Digitada' });
                this.alertNF.addInput({ type: 'checkbox', value: 'a2', checked: false, label: 'Fechada' });
                this.alertNF.addInput({ type: 'checkbox', value: 'a3', checked: false, label: 'Cancelada' });
                this.alertNF.addInput({ type: 'checkbox', value: 'a4', checked: false, label: 'Documento Fiscal Emitido' });
                this.alertNF.addInput({ type: 'checkbox', value: 'a5', checked: false, label: 'Aguardando Fechamento' });
                this.alertNF.addInput({ type: 'checkbox', value: 'a6', checked: false, label: 'Aguardando Integração WMS' });

                this.alertNF.addInput({ type: 'checkbox', value: '0',   disabled: true, checked: false, id: 'optGroup', label: 'Status NFe' });
                this.alertNF.addInput({ type: 'checkbox', value: 'b1',  checked: false, label: 'Não Enviada' });
                this.alertNF.addInput({ type: 'checkbox', value: 'b2',  checked: false, label: 'Enviada' });
                this.alertNF.addInput({ type: 'checkbox', value: 'b3',  checked: false, label: 'Autorizada' });
                this.alertNF.addInput({ type: 'checkbox', value: 'b4',  checked: false, label: 'Rejeitada' });
                this.alertNF.addInput({ type: 'checkbox', value: 'b5',  checked: false, label: 'Denegada' });
                this.alertNF.addInput({ type: 'checkbox', value: 'b6',  checked: false, label: 'Solicitado Inutilização' });
                this.alertNF.addInput({ type: 'checkbox', value: 'b7',  checked: false, label: 'Solicitado Cancelamento' });
                this.alertNF.addInput({ type: 'checkbox', value: 'b8',  checked: false, label: 'Inutilizada' });
                this.alertNF.addInput({ type: 'checkbox', value: 'b9',  checked: false, label: 'Cancelada' });
                this.alertNF.addInput({ type: 'checkbox', value: 'b10', checked: false, label: 'Erro Geração' });
                this.alertNF.addInput({ type: 'checkbox', value: 'b11', checked: false, label: 'Erro Solicitação Cancelamento' });
                this.alertNF.addInput({ type: 'checkbox', value: 'b12', checked: false, label: 'Erro Solicitação Inutilização' });
                this.alertNF.addInput({ type: 'checkbox', value: 'b13', checked: false, label: 'Pendente De Cancelamento' });
                this.alertNF.addInput({ type: 'checkbox', value: 'b14', checked: false, label: 'Solicitado Encerramento' });
                this.alertNF.addInput({ type: 'checkbox', value: 'b15', checked: false, label: 'Encerrado MDFe' });
                this.alertNF.addInput({ type: 'checkbox', value: 'b16', checked: false, label: 'Autorizado Em Contingência' });
                this.alertNF.addInput({ type: 'checkbox', value: 'b17', checked: false, label: 'Evento Registrado' });
                this.alertNF.addInput({ type: 'checkbox', value: 'b18', checked: false, label: 'Deferido Parcial' });
                this.alertNF.addInput({ type: 'checkbox', value: 'b19', checked: false, label: 'Indeferido' });
            } else {
                let dataInputs: any = this.alertNF.data.inputs;
                this.alertNF = this.alertCtrl.create();
                this.alertNF.setTitle(this.title);
                this.alertNF.data.inputs = dataInputs;
            }
            this.alertNF.addButton('CANCELAR');
            this.alertNF.addButton({
                text: 'FILTRAR',
                handler: (data: any) => {
                    resolve(data);
                }
            });
            return this.alertNF.present();
        });
    }

}


// WEBPACK FOOTER //
// ./src/providers/util/statusNF.service.ts